import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { MY_EXIM_API_RFQ } from "../../appRedux/services/requestQuotationsNetwork";
import { formatDate, isVerifiedFreightEligible, showAlert } from "../../util/helper";
import RFQStatusTags from "../../routes/requestQuotation/RFQStatus";
import { Card, Image, List} from "antd";
import { DownloadOutlined, LeftOutlined } from "@ant-design/icons";
import VerifiedFreightTag from "../../components/VerifiedFreightTag";

const QuotationDetailsAdmin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const quotationIdForRating = id;
  const [fileName, setFileName] = useState("");
  const [quotationsData, setQuotationsData] = useState(null);
  const [messageSubmit, setMessageSubmit] = useState(false);

  useEffect(
    () => {
      if (isArrayNonEmpty(quotationsData?.attachments)) {
        setFileName(quotationsData?.attachments);
      }
      if (messageSubmit) {
        setMessageSubmit(false);
      }
    },
    [quotationsData],
    [messageSubmit]
  );

  useEffect(() => {
    window.scrollTo({ top: -100, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      MY_EXIM_API_RFQ.getQuotationDetails({ id })
        .then((response) => {
          setQuotationsData(response?.data?.data);
          dispatch(fetchSuccess());
        })
        .catch((e) => {
          showAlert(e?.message);
          dispatch(fetchSuccess());
        });
    }
  }, []);

  const {
    sender,
    price,
    units,
    description,
    enquiries,
    createdAt,
    currencyCode,
    status,
    paymentTerms,
  } = quotationsData ?? {};

  const { shipmentMode, shipmentType, containerType } =
    quotationsData?.enquiries ?? {};

  const unitsDisplay =
    shipmentMode === "sea"
      ? shipmentType === "fcl"
        ? `Unit (${containerType || "N/A"})`
        : "Cubic Meter"
      : units;

  const { companyName, country } = sender ?? {};
  let data = [
    {
      label: "Received Date",
      value: formatDate(createdAt),
    },
    {
      label: "Company Name",
      value: (
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span>{companyName}</span>
          {isVerifiedFreightEligible(sender) && (
            <VerifiedFreightTag verifiedFreight={sender?.verifiedFreight} />
          )}
          <span
            onClick={() =>
              navigateBusinessCard(sender?.id, quotationIdForRating)
            }
            className={"myexim-link"}
          >
            View Profile
          </span>
        </div>
      ),
    },
    isValidString(country) && {
      label: "Destination Country",
      value: enquiries.destinationCountry,
    },
    isValidString(country) && {
      label: "Destination Port",
      value: enquiries.destinationPort,
    },
    isValidString(paymentTerms) && {
      label: "Delivery Terms",
      value: paymentTerms,
    },
    isValidString(currencyCode) &&
      isValidString(price) &&
      (shipmentMode && shipmentType
        ? isValidString(containerType)
        : isValidString(units)) && {
        label: "Price / Unit",
        value: `${currencyCode} ${price} / ${unitsDisplay}`,
      },
    isValidString(enquiries?.qty) && {
      label: "Total Quantity",
      value: `${enquiries?.qty} ${units}`,
    },
    {
      label: "Response Message",
      value: description,
    },
    {
      label: "Status",
      value: <RFQStatusTags status={status} />,
    },
  ];
  const navigateBusinessCard = useCallback(
    (id) => {
      history.push(`/enquiries/view-profile?id=${id}`);
    },
    [history]
  );

  if (isValidElement(companyName)) {
    return (
      <>
        <Card className="myexim-detail-card">
          <div className="myexim-table-title">
            <LeftOutlined
              className={"back-icon"}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
            Quotation Details
          </div>
          <div className="gx-pl-4">
            <List
              className="gx-mt-4"
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) =>
                item?.value && (
                  <List.Item className="myexim-details-list">
                    <List.Item.Meta
                      title={<div>{item.label}</div>}
                      description={item.value}
                    />
                  </List.Item>
                )
              }
            />
          </div>
          {fileName?.length > 0 && (
            <div className="attachments gx-pl-2">
              <div className="sub-header">Attachments</div>
              <div className="gx-pt-4">
                {fileName?.map((file, index) => (
                  <div key={index} className="gx-pb-3">
                    <Image
                      width={150}
                      height={150}
                      src={file?.src}
                      alt={file?.originalName}
                    />
                    <div className="gx-pt-2">
                      <a
                        href={file?.downloadUrl || file?.src}
                        download={file?.originalName}
                        className="download-link"
                        style={{
                          color: "#1677ff",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <DownloadOutlined style={{ fontSize: "18px" }} />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Card>
      </>
    );
  } else return null;
};
export default QuotationDetailsAdmin;
